export const makeSelectOptions = <T,>(array: readonly T[]) => {
  return array.map((val) => ({
    label: val,
    value: val,
  }));
};
